import { oz } from '@weft/utils';

export const REPORT_JOB_TYPES = Object.freeze({
  CommitmentUsage: 'CommitmentUsage',
  UnchargedUsage: 'UnchargedUsage',
  ProductsUsage: 'ProductsUsage',
  CustomerRevenue: 'CustomerRevenue',
  Contracts: 'Contracts',
  AnonymousCustomers: 'AnonymousCustomers',
  MonthlyClosure: 'MonthlyClosure',
});

export const ReportJobTypesSchema = oz.nativeEnum(REPORT_JOB_TYPES);

export type ReportJobTypes = oz.TypeOf<typeof ReportJobTypesSchema>;